var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-items-center"},[(_vm.thumb)?_c('div',{staticClass:"mr-2",staticStyle:{"height":"30px","width":"30px"}},[_c('img',{staticClass:"img-thumbnail p-0 img-fluid h-100 w-100",attrs:{"src":_setup.getThumbUrl(_vm.thumb)}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }